import React from 'react'

// Disable automatic dark mode - design is light by default
// Only the footer should be dark
if (typeof window !== 'undefined') {
  document.documentElement.classList.remove('dark')
}

export const wrapRootElement = ({ element }: { element: React.ReactElement }) => {
  return element
}






